// src/app/actions/remindersReducer.js
import {
  FETCH_REMINDER_SETTINGS_REQUEST,
  FETCH_REMINDER_SETTINGS_SUCCESS,
  FETCH_REMINDER_SETTINGS_FAILURE,
  SAVE_REMINDER_SETTINGS_REQUEST,
  SAVE_REMINDER_SETTINGS_SUCCESS,
  SAVE_REMINDER_SETTINGS_FAILURE
} from './reminders'

const initialState = {
  settings: null,
  isLoading: false,
  isSaving: false,
  error: null
}

export default function remindersReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REMINDER_SETTINGS_REQUEST:
      return { ...state, isLoading: true, error: null }

    case SAVE_REMINDER_SETTINGS_REQUEST:
      return { ...state, isSaving: true, error: null }

    case FETCH_REMINDER_SETTINGS_SUCCESS:
      return { ...state, isLoading: false, settings: action.payload }

    case SAVE_REMINDER_SETTINGS_SUCCESS:
      return { ...state, isSaving: false, settings: action.payload }

    case FETCH_REMINDER_SETTINGS_FAILURE:
      return { ...state, isLoading: false, error: action.payload }

    case SAVE_REMINDER_SETTINGS_FAILURE:
      return { ...state, isSaving: false, error: action.payload }

    default:
      return state
  }
}
